import { MailOutline } from "@material-ui/icons";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/Commission/create.js";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import PropTypes from "prop-types";
import { bookingApi } from "functions/apis";
import CustomInput from "components/CustomInput/CustomInput";

const useStyles = makeStyles(styles);

const defaultState = {
  code: "",
  description: ""
};

export default function Create(props) {
  const [redirect, setRedirect] = useState(false);
  const [state, setState] = useState({ ...defaultState });
  const [disabled, setDisabled] = React.useState(false);
  const [redirectId, setRedirectId] = React.useState();

  const abortController = React.useRef(new AbortController());

  useEffect(() => {
    return () => abortController.current.abort();
  }, []);

  const handleCodeChanged = e => setState({ ...state, code: e.target.value });

  const handleDescriptionChanged = e =>
    setState({ ...state, description: e.target.value });

  const handleSubmit = () => {
    setDisabled(true);
    bookingApi
      .post("/FeePolicies", state, {
        signal: abortController.current.signal
      })
      .then(data => {
        setRedirectId(data);
        setRedirect(true);
      })
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const classes = useStyles();

  return redirect ? (
    <Redirect to={`/admin/FeePolicy/Detail/${redirectId}`} />
  ) : (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>CREATE FEE POLICY</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <GridContainer>
              <GridItem xs={12} md={12}>
                <CustomInput
                  labelText="Code"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleCodeChanged,
                    value: state.code ?? ""
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={12}>
                <CustomInput
                  labelText="Description"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleDescriptionChanged,
                    value: state.description ?? ""
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={12}>
                <Button
                  disabled={disabled}
                  color="rose"
                  type="submit"
                  value="Submit"
                  onClick={() => handleSubmit()}
                >
                  Submit
                </Button>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

Create.propTypes = {
  history: PropTypes.object
};
